
import { useCredit } from '../../../hooks'

export default function LastCreditPresenter() {
    const {lastCreditQuery} = useCredit()
 

    if (lastCreditQuery.isError) {
      return <>Error</>
    }

    if (lastCreditQuery.isLoading) {
      return <>...</>
    }

    
       const lastCredit = lastCreditQuery.data?.[0]?.Value  || 'NA'

  return (

      <>{lastCredit}</>

  
  )
}
